import jobs from './jobs';
import layout from './layout';
import trips from './trips';

const index = {
  jobs,
  trips,
  layout,
};

export default index;
